/**
 * 程序主组件
 * 创建时间：2017-02-22
 *   创建人：zhanlz
 */
<template>
  <div id="wrapper">
  		 <app-sidebar></app-sidebar>
  		 <app-content
  		 	v-if="hasPermission && levv!=''"
  		 	v-on:opentip="opentip"
  		 	></app-content>
  		 <AppRightSidebar></AppRightSidebar>
  		 <AppAlarmRightSidebar
  		 	v-on:openAlarm="openAlarm"
  		 	v-on:opentip="opentip"
  		 	></AppAlarmRightSidebar>
  		 <AppBackMission
  		 	v-if="showBackMission"
  		 	v-on:stopTask="stopTask"
  		 	v-on:openTip="opentip"
  		 	:stopped="stopped"
  		 	></AppBackMission>	
  		 <!--报警弹框-->
		<main-modal ref="mModal" size="large" title="报警处理" v-on:cancel="closeModal">
			<div>
				<page-alarm-handle-edit 
						:data="alarmDetail"
						v-on:handleSave="closeAlarm">  
				</page-alarm-handle-edit>
			</div>
		</main-modal>
		<!--后台任务弹框-->
		<main-modal ref="bModal" size="large" title="警告" v-on:cancel="closeWarning">
			<div>
				<p>该任务尚未完成，中断后此任务将被取消，您确定要继续吗？</p>
			</div>
			<div slot="footer">
				<button class="btn btn-primary" @click="closeWarning">取消</button>
				<button class="btn btn-primary" @click="confirmToStop">确定</button>
			</div>
		</main-modal>
		<!--提示弹框-->
		<main-modal ref="tModal" size="small" title="温馨提示" v-on:cancel="closetip">
			<div>
				<p>{{tipContent}}</p>
			</div>
			<div slot="footer">
				<button class="btn btn-primary" @click="closetip">关闭</button>
			</div>
		</main-modal>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import AppSidebar from 'components/layouts/Sidebar';
import AppContent from 'components/layouts/MainContent';
import AppRightSidebar from 'components/layouts/RightSidebar';
import AppAlarmRightSidebar from 'components/layouts/AlarmRightSidebar';
import MainModal from 'components/common/MainModal'
import PageAlarmHandleEdit from 'components/pages/alarmhandle/PageAlarmHandleEdit'
import AppBackMission from 'components/layouts/BackMission'
export default {
  name: 'home',
  components: {
  	 AppSidebar,
     AppContent,
     AppRightSidebar,
     AppAlarmRightSidebar,
     MainModal,
     PageAlarmHandleEdit,
     AppBackMission
  },
  data(){
  	return {
  		tipContent:'',
  		alarmDetail:{},
  		taskId:'',
  		stopped:false
  	}
  },
  computed:mapState({
  	homeTipShow:state => state.home.homeTipShow,
  	showBackMission:state => state.global.showBackMission,
  	homeTipTxt:state => state.home.homeTipTxt,
	hasPermission:state=>state.permission.hasPermission,
	levv:state => state.user.levv
  }),
  watch:{
  	homeTipShow(val){
  		const that = this
  		if(val){
  			this.opentip(that.homeTipTxt)
  		}else{
  			this.closetip()
  		}
  	} 
  }, 
  methods:{
  	/*后台任务警告相关*/
  	stopTask(id){
  		this.taskId = id
  		this.closetip()
  		this.$store.dispatch('showMission',false)
  		this.confirmToStop()
  	},
  	closeWarning(){
		this.$refs.bModal.close()
	},
	confirmToStop(){//确认中断任务
		this.$http.delete(process.env.API_ROOT + '/home/backtask',{params:{taskId:this.taskId}})
		.then(res=>{
			//获取中断时多少条 
			this.closeWarning()
			this.opentip(res.body.message)
			this.stopped = true
		},res=>{
			this.opentip(res.body.message)
		})
		.catch(res=>{
			this.opentip('请求异常')
		})
	},
  	/*报警提示相关*/
  	openAlarm(obj){
		this.$http.get(process.env.API_ROOT + '/alarm/alarms/' + obj.alarmId)
		.then(res=>{
			this.alarmDetail = res.body.data
			this.$refs.mModal.open();
		},res=>{
			this.$refs.tModal.open()
			this.tipContent = res.body.message
		})
		.catch(res=>{
			this.$refs.tModal.open()
			this.tipContent = OPERATE_EXCEPTION
		})		
	},
  	closeAlarm(almLevel){
		var parm = {
			almLevel:almLevel,
			planOwnerType:1,
			page_index:1
		};
		this.$store.dispatch('showAlarmInfo', parm);
		this.$store.dispatch('getAlarmNum');
		this.$refs.mModal.close()
	},
	closeModal(){
		this.$refs.mModal.close()
	},
	/*消息提示相关*/
  	opentip(tip){
		this.$refs.tModal.open()
		this.tipContent = tip
	},
  	closetip(){
		this.$refs.tModal.close()
		this.$store.dispatch('closeMainTip')
	}
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?b588a6c4